import IconLanguage from '@bimser/icons/16/language';
import * as React from 'react';
import { BCButton, BCFlex, BCSpaceCompact, BCTextArea } from '..';
import { findMessage } from '../BCIntl';
import BCLabel from '../BCLabel';
import BCPopover from '../BCPopover';
import BCScrollbars from '../BCScrollbars';
import { ITextAreaChangeEventArgs } from '../BCTextArea/entities';
import Style from './assets/style.scss';
import { IProps } from './entities';

const inputStyle: React.CSSProperties = { width: 'calc(100% - 35px)' };
const buttonStyle: React.CSSProperties = { width: '35px', fontWeight: 900, fontSize: '14px' };
const scrollbarStyle: React.CSSProperties = { height: 305, width: 410, maxWidth: '80vw' };
const labelStyle: React.CSSProperties = { fontSize: 13 };

const BCTextAreaMultiLanguage = (props: IProps) => {
	const renderPopoverContent = () => (
		<BCScrollbars
			cssClass={Style.scrollbar}
			styles={scrollbarStyle}
		>
			<BCFlex
				vertical
				className={Style.content}
				gap={12}
			>
				{props.supportedLanguages.map(item => {
					if (item.id != props.currentLanguage.id) {
						return (
							<BCFlex
								vertical
								gap={4}
								key={item.name}
							>
								<span
									className={Style.label}
									title={item.name}
								>
									{item.name}
								</span>
								<BCTextArea
									itemKey={item.culture}
									onChange={onLanguageValueChange}
									value={props.values && props.values[item.culture]}
									autosize={props.autosize || { minRows: 3, maxRows: 5 }}
									regExp={props.regExp}
									placeHolder={props.innerInputProps?.placeHolders?.getText(
										item.culture
									)}
									maxLength={props.maxLength}
									{...(props.innerInputProps || {})}
								/>
							</BCFlex>
						);
					}
				})}
			</BCFlex>
		</BCScrollbars>
	);

	const onLanguageValueChange = (e: ITextAreaChangeEventArgs) => {
		props.onLanguageValueChange?.(e.itemKey, e.data);
	};

	const onVisibilityChange = (visible: boolean) => {
		props.onVisibilityChange?.(visible);
	};

	const renderPopoverTitle = () =>
		props.title || <BCLabel customStyles={labelStyle}>{findMessage.get('100775')}</BCLabel>;

	const renderInput = () => {
		if (props.renderInput) {
			return <div style={inputStyle}>{props.renderInput()}</div>;
		}

		return (
			<BCTextArea
				placeHolder={props.placeHolder}
				itemKey={props.currentLanguage.culture}
				onChange={onLanguageValueChange}
				value={props.values && props.values[props.currentLanguage.culture]}
				regExp={props.regExp}
				style={inputStyle}
				rows={props.rows}
				maxLength={props.maxLength}
			/>
		);
	};

	return (
		<BCSpaceCompact
			block
			size={props.size}
		>
			{renderInput()}
			<BCPopover
				content={renderPopoverContent()}
				title={renderPopoverTitle()}
				trigger={props.trigger || 'click'}
				placement={props.placement || 'leftTop'}
				overlayClassName={Style.overlay}
				onOpenChange={onVisibilityChange}
				getPopupContainer={props.getPopupContainer}
			>
				<BCButton
					style={buttonStyle}
					icon={<IconLanguage />}
				/>
			</BCPopover>
		</BCSpaceCompact>
	);
};

export default BCTextAreaMultiLanguage;
export { IProps as ITextAreaMultiLanguageProps };
